module.exports = __webpack_public_path__ + "img/binary_mintert_rund.71fcb1c5.svg";